import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetInvoiceDetailsQuery } from "../../../services/Reports";
import {
  getInvoiceDetailsRequest,
  getInvoiceDetailsFailure,
  getInvoiceDetailsSuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allInvoiceDetails,
    isLoading: invoiceDetailsLoading,
    isError: invoiceDetailsError,
  } = useGetInvoiceDetailsQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.invoiceDetailsPageNo,
    pageSize: state.invoiceDetailsPageSize,
    fromDate: new Date(state.invoiceDetailsFromDate).toLocaleDateString(),
    toDate: new Date(state.invoiceDetailsToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (invoiceDetailsLoading) {
      dispatch(getInvoiceDetailsRequest());
    }
    if (invoiceDetailsError) {
      dispatch(getInvoiceDetailsFailure(invoiceDetailsError));
    }
    if (allInvoiceDetails) {
      dispatch(
        getInvoiceDetailsSuccess({
          data: allInvoiceDetails.data.invoiceDetails[0].data || [],
          totalPages:
            allInvoiceDetails.data.invoiceDetails[0].metadata[0]?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allInvoiceDetails,
    profileData,
    state.invoiceDetailsFromDate,
    state.invoiceDetailsToDate,
    state.invoiceDetailsPageNo,
    state.invoiceDetailsPageSize,
  ]);
  return <></>;
};
export default Content;
